import { render, staticRenderFns } from "./MultipleConsigneesModal.vue?vue&type=template&id=05b6c4ce&scoped=true"
import script from "./MultipleConsigneesModal.vue?vue&type=script&lang=js"
export * from "./MultipleConsigneesModal.vue?vue&type=script&lang=js"
import style0 from "./MultipleConsigneesModal.vue?vue&type=style&index=0&id=05b6c4ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b6c4ce",
  null
  
)

export default component.exports